export default __webpack_public_path__ + "static/media/Pistol_7.56c2c311.png";